import {
  ResponseBaseModel,
  TransactionDueDateListModel,
  TransactionDueDateModel,
  TransactionDueDateSearchParamsModel,
} from "../models";
import AlYusrAxiosApiInstance, {
  AxiosSearchParams,
} from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
export const searchTransactionDueDate = async (
  request?: TransactionDueDateSearchParamsModel
): Promise<ResponseBaseModel<TransactionDueDateListModel[]>> => {
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.transactionDueDateController.getAllTransactionsDueDate,
    { params: AxiosSearchParams(request ?? {}, "searchParamter") }
  );
};

export const getTransactionDueDateById = async (
  transactionDueDateId: number
): Promise<ResponseBaseModel<TransactionDueDateModel>> => {
  return await AlYusrAxiosApiInstance.get(
    `${AlYuserApiUrls.transactionDueDateController.getTransactionDueDateById}?`,
    {
      params: {
        transactionDueDateId,
      },
    }
  );
};
export const saveTransactionDueDate = async (
  transactionDueDate: TransactionDueDateModel
): Promise<ResponseBaseModel<TransactionDueDateModel>> => {
  return await AlYusrAxiosApiInstance.post(
    AlYuserApiUrls.transactionDueDateController.saveTransactionDueDate,
    transactionDueDate
  );
};
